// Team Operations (team detail > Operations): a team's Communication Channel, Process and Tools & Technology Stack.
// Row labels are List Manager details; a field is (itemId, attributeId); every save is kept.
// The Operations tabs, in order; each loads and saves on its own (get-team-operations/{key}, save-team-operations/{key})
export const TEAM_OPERATIONS_SECTIONS = [
    { key: "communication", name: "Communication Channel" },
    { key: "process", name: "Process" },
    { key: "tools", name: "Tools & Technology Stack" },
];
// A field's key in the section modals' typed values
export const teamOperationsFieldKey = (itemId, attributeId) => `${itemId}|${attributeId || ""}`;
// A section is set up once any of its fields has a value recorded
export const teamOperationsSectionHasValues = (section) => section.groups.some((group) => group.rows.some((row) => row.fields.some((field) => !!field.current)));
// "Voice Calls — Media"; Tools rows have a single value, so just the label
export const teamOperationsFieldLabel = (row, field) => (field.attributeId ? `${row.label} — ${field.attributeName}` : row.label);
